import { Component, Input } from '@angular/core';

type Labeled = {};

@Component({
  selector: 'app-ng-select-multi-label-tmp',
  templateUrl: './ng-select-multi-label-tmp.component.html',
})
export class NgSelectMultiLabelTmpComponent {
  @Input() items: Labeled[] = [];
  @Input() selected: Labeled[] = [];
  @Input() max: number = 1;
  @Input() bindLabel: string = 'label';
  @Input() allLabel: string = 'Tous';
  @Input() multiple: boolean = false;
}
